import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { prefetchMasonryNode } from "utils/masonry-node-prefetch";

export const usePrefetchMasonryNode = (rootNodeId: string) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    prefetchMasonryNode(queryClient, rootNodeId);
  }, [queryClient, rootNodeId]);
};
